import { render } from "./FooterComponent.vue?vue&type=template&id=7b4513a7&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=7b4513a7&scoped=true&lang=css"
import "@/assets/css/footer_computer.css?vue&type=style&index=1&id=7b4513a7&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4513a7"]])

export default __exports__